import React from 'react';
import { useController, useForm } from 'react-hook-form';
import IconButton from 'components/shared/IconButton';
import { CheckIcon, CloseIcon } from 'components/icons';
import { usePreferenceFormResolver } from '../../hooks';
import styles from './PreferenceNameEditor.module.css';

function PreferenceNameEditor({ preference, onSubmit, onCancel }) {
  const resolver = usePreferenceFormResolver({ category: preference.category });
  const methods = useForm({
    mode: 'onBlur',
    defaultValues: preference,
    resolver
  });
  const { control, handleSubmit } = methods;
  const {
    field: { value, onChange, onBlur },
    fieldState: { error, isDirty }
  } = useController({ name: 'name', control });

  return (
    <div className={styles.root}>
      <div className={styles.control}>
        <input type="text" value={value} className={styles.input} onBlur={onBlur} onChange={onChange} />
        <IconButton
          aria-label="Submit"
          variant="contained"
          color="primary"
          size="x-small"
          className={styles.action}
          disabled={!isDirty || error != null}
          onClick={handleSubmit(onSubmit)}
        >
          <CheckIcon />
        </IconButton>
        <IconButton
          aria-label="Cancel"
          variant="outlined"
          color="primary"
          size="x-small"
          className={styles.action}
          onClick={onCancel}
        >
          <CloseIcon />
        </IconButton>
      </div>
      {error ? <div className={styles.error}>{error.message}</div> : null}
    </div>
  );
}

export default PreferenceNameEditor;
